import { _ } from "../../../polyglot/polyglot.js";
import AbstractFormStep from "../../AbstractFormStep.js";

/**
 * The step to choose various import options for capego.
 */
export default class FiscalYearSelectionStep extends AbstractFormStep {
	_populateForm(form) {
		const sieFiles = this._sortSieFiles({
			sieFiles: this._context.sieFiles || [],
		});

		const dropdownItems = sieFiles.map((sieFile) => ({
			label: sieFile.toString(),
			value: sieFile,
		}));

		form.newDropDownField({
			label: _("Fiscal period"),
			items: dropdownItems,
			attribute: "selectedSieFile",
			dataTestName: "sie-file",
		});
	}

	/**
	 * Return a sorted array of SIE files. SIE files are sorted by
	 * period type first (years first, then months), and SIE files of
	 * the same period type are sorted by ascending date.
	 *
	 * @param {SieFiles} sieFiles -
	 */
	_sortSieFiles({ sieFiles }) {
		const yearSieFiles = sieFiles.getSortedSieFiles({
			predicate: (sieFile) => sieFile.isForYear(),
		});

		const nonYearSieFiles = sieFiles.getSortedSieFiles({
			predicate: (sieFile) => !sieFile.isForYear(),
		});

		return [...yearSieFiles, ...nonYearSieFiles];
	}
}
